<div class="m-subheader" appunwraptag="">
	<div class="d-flex align-items-center">
		<div class="mr-auto">
			<h3 class="m-subheader__title m-subheader__title--separator">
				ToT/ToA Dashboard
			</h3>
			<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
				<li class="m-nav__item m-nav__item--home">
					<a class="m-nav__link m-nav__link--icon">
						<i class="la la-briefcase"></i>
					</a>
				</li>
				<li class="m-nav__separator">
					-
				</li>
				<li class="m-nav__item">
					<span class="m-nav__link-text">
						My Batches
					</span>
				</li>
			</ul>
		</div>
	</div>
</div>

<div class="m-content" *ngIf="batchFeeDetailsForm">
	<div class="m-portlet m-portlet--tab">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-text title-style">
					<label class="col-md-3 col-lg-3 col-sm-2">My Batches</label>
					<button class="btn btn-secondary pull-right" routerLink="../search-batch">
						Search a Batch
					</button>
					<button class="btn btn-secondary pull-right" (click)="goBack()">
						Back
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="m-portlet__body footer-align">
		<div class="col-lg-10">
			<app-tot-toa-data-filter [customFilter]="customFilterFields" (searchFilters)="getFilterData($event)"
				(resetFilters)="resetFilter()"></app-tot-toa-data-filter>
		</div>
		<!-- <div class="m-portlet__body"> -->
		<!-- Searched Job Roles: <span class="color-info"></span> -->
		<table class="table table-striped m-table">
			<thead class="m-datatable__head">
				<tr class="m-datatable__row">
					<th>
						<b>Batch ID</b>
					</th>
					<th>
						<b>Batch Type</b>
					</th>
					<th>
						<b>Batch Mode</b>
					</th>
					<th>
						<b>Location</b>
					</th>
					<th>
						<b>Job Role Name(QP Code)</b>
					</th>
					<th>
						<b>Current Status</b>
					</th>
					<th>
						<b>Status Action Date</b>
					</th>
					<th>
						<b>Action</b>
					</th>
				</tr>
			</thead>
			<tbody class="notranslate">
				<tr *ngFor="let data of applicantData; let i = index">
					<td>{{data?.batch?.batchId}}</td>
					<td>{{data?.batch?.type}}</td>
					<td>{{data?.batch?.totMode || 'N/A'}}</td>
					<td>{{data.batch.address ? data.batch.address.state.name : 'N' }}/{{data.batch.address ?
                        data.batch.address.district.name : 'A'}}</td>
					<td>
						<span *ngFor="let jobs of data.batch.jobRoles; let isLast=last">
							{{jobs.jobName}} ({{jobs.qpCode}}) {{isLast ? '' : ', '}}
						</span>
					</td>
					<td>{{data.disp_txt}}</td>
					<td>
						<ng-container *ngIf="data.batch.candidates.userName == userInfo.userName">
							<span
								*ngIf="data.batch.candidates && data.batch.candidates.statusChangedOn; else elseBlock">
								{{data?.batch?.candidates?.statusChangedOn | date:"dd-MM-yyyy"}}
							</span>
							<ng-template #elseBlock>
								N/A
							</ng-template>
						</ng-container>
					</td>
					<td data-field="Actions" class="m-datatable__cell">
						<span style="overflow: visible; width: 100px;">
							<div class="dropdown">
								<a href="javascript:;"
									class="btn m-btn m-btn--hover-accent ellipsis-btn m-btn--icon m-btn--icon-only m-btn--pill"
									data-toggle="dropdown">
									<i class="la la-ellipsis-h"></i>
								</a>
								<ul class="dropdown-menu dropdown-menu-right multi-level" role="menu"
									aria-labelledby="dropdownMenu">
									<li class="dropdown-item" data-keyboard="false" data-backdrop="static">
										<a href="javascript:;"
											routerLink="../view-batch-details/{{data.batch.status}}/{{data.batch.batchId}}">
											View Details
										</a>
									</li>
									<li class="dropdown-item" data-keyboard="false" data-backdrop="static"
										*ngIf="data.disp_txt === 'Enrolled' && !data?.batch?.candidates?.paymentDetails?.modeOfPayment">
										<a href="javascript:;" data-target="#add_payment_modal" data-toggle="modal"
											(click)="openModal(data)">
											Add Payment Details
										</a>
									</li>
									<li class="dropdown-item" data-keyboard="false" data-backdrop="static"
										*ngIf="data.disp_txt === 'Rejected'">
										<a href="javascript:;" (click)="showComment(data)"
											data-target="#view_comment_modal" data-toggle="modal">
											View Comments
										</a>
									</li>
									<li class="dropdown-item" data-keyboard="false" data-backdrop="static"
										*ngIf="data.disp_txt === 'Certified' && !data.batch.candidates.feedback">
										<a class="dropdown-item" (click)="provideFeedback(data.batch)">
											Provide Feedback
										</a>
									</li>
									<li class="dropdown-item" data-keyboard="false" data-backdrop="static"
										data-toggle="modal" data-target="#provide_feedback_modal"
										*ngIf="data.disp_txt === 'Certified' && data.batch.candidates.feedback">
										<a class="dropdown-item" (click)="viewFeedback(data.batch)">
											View Feedback
										</a>
									</li>
									<!-- <li class="dropdown-item" data-keyboard="false" data-backdrop="static">
												<a class="dropdown-item" data-target="#provide_feedback_modal" data-toggle="modal" (click)="assignBatchData(data)">
													Provide Feedback
												</a>
											</li> -->
									<!-- <li class="dropdown-item dropdown-submenu"> -->
									<li class="dropdown-item dropdown-submenu"
										*ngIf="(data.disp_txt === 'Certified' || data.disp_txt === 'Approved') && (data.batch && data.batch.showDownload)">
										<ng-container>
											<a tabindex="-1" href="javascript:;" data-keyboard="false"
												data-backdrop="static">
												<i class="la la-angle-left" style="margin-right: 35px;"></i>Download
												Marksheet</a>
											<ul class="dropdown-menu">
												<ng-container *ngFor="let jobRole of data.batch.candidates.jobRole">
													<li class="dropdown-item" *ngIf="jobRole?.isMarkSheetGenerated">
														<a tabindex="-1" href="javascript:;"
															(click)="getMarksheetDetails(data.batch.batchId, jobRole.qpCode)">{{jobRole?.qpName}}</a>
													</li>
												</ng-container>
											</ul>
										</ng-container>
									</li>
									<!-- <li class="dropdown-item dropdown-submenu"> -->
									<li class="dropdown-item dropdown-submenu" *ngIf="data.disp_txt === 'Certified'">
										<a tabindex="-1" href="javascript:;" data-keyboard="false"
											data-backdrop="static">
											<i class="la la-angle-left" style="margin-right: 35px;"></i>Download
											Certificate</a>
										<ul class="dropdown-menu">
											<ng-container
												*ngFor="let jobRole of data.batch.candidates.jobRole; let i = index">
												<li class="dropdown-item"
													*ngIf="jobRole?.isPlatformQP === false && jobRole?.isCertified">
													<a tabindex="-1" href="javascript:;"
														(click)="getCertificateDetails(data.batch, jobRole.qpCode)">{{jobRole?.qpName}}</a>
												</li>
											</ng-container>
										</ul>
									</li>
									<li class="dropdown-item dropdown-submenu" *ngIf="data.disp_txt === 'Certified'">
										<a tabindex="-1" href="javascript:;" data-keyboard="false"
											data-backdrop="static">
											<i class="la la-angle-left" style="margin-right: 35px;"></i>Apply for
											Advanced Certification</a>
										<ul class="dropdown-menu">
											<ng-container
												*ngFor="let jobRole of data.batch.candidates.jobRole; let i = index">
												<li class="dropdown-item"
													*ngIf="jobRole?.isPlatformQP === false && jobRole?.isCertified">
													<a tabindex="-1" href="javascript:;"
														(click)="applyAdvancedCertificate(data.batch, jobRole)">{{jobRole?.qpName}}</a>
												</li>
											</ng-container>
										</ul>
									</li>
								</ul>
							</div>
						</span>
					</td>
				</tr>
			</tbody>
		</table>
		<app-pagination [count]=count (pageNumber)="assignPageNo($event)"
			(recordsPerPage)="assignRecordsPerPage($event)"></app-pagination>
		<!-- </div> -->
	</div>
</div>

<div class="modal fade" id="m_modal_2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle">
	<div class="modal-dialog align " role="document">
		<div class="modal-content align_content">
			<div class="modal-header">
				<h3 id="exampleModalLongTitle">View Certificate Details
				</h3>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Applicant ID: </B>{{currentCertificate?.userName}}
						</div>
					</div>
				</div>
				<br>
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Job Role (QP Code):
							</B>({{currentCertificate?.qpCode}}) - v{{currentCertificate?.qpVersion}}
						</div>
						<div class="col-md-4">
							<B>Certificate Issue Date: </B>
							<span
								*ngIf="currentCertificate && currentCertificate?.dateOfIssue; else elseBlockA">{{currentCertificate?.dateOfIssue | date: 'dd/MM/yyyy'}}</span>
							<ng-template #elseBlockA>N/A</ng-template>
						</div>
						<div class="col-md-4">
							<B>Valid Till Date: </B>
							<span
								*ngIf="currentCertificate && currentCertificate?.validUpto; else elseBlockB">{{currentCertificate?.validUpto | date: 'dd/MM/yyyy'}}</span>
							<ng-template #elseBlockB>N/A</ng-template>
						</div>
					</div>
				</div>
				<br>
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Certificate/Provisional Certificate Document: </B>
							<span class="" *ngIf="certificateFileName; else noCertificateDoc">
								<div (click)="downloadCertificate(currentCertificate?.key)"
									style="color:#0092D8;cursor: pointer;">
									{{certificateFileName}}
								</div>
							</span>
							<ng-template #noCertificateDoc>N/A</ng-template>
						</div>
						<div class="col-md-4">
							<B>Validity Extended: </B>
							<span>{{currentCertificate?.isValidityExtended ? 'Yes' : 'No' }}</span>
						</div>
						<div class="col-md-8" *ngIf="currentCertificate?.isValidityExtended">
							<B>Extended Validity: </B> <span>Valid Till Date extended from</span>
							{{ currentCertificate?.validityExtensionDetails?.oldValidityDate | date: 'dd/MM/yyyy' }}<span>
								to </span> {{ currentCertificate?.validUpto | date: 'dd/MM/yyyy' }} <span>under special
								circumstances –</span>
							{{ currentCertificate?.validityExtensionDetails?.reasonForValidityExtension }}
						</div>
					</div>
				</div>
				<br>
			</div>
			<div class="modal-footer default">
				<button type="button" class="btn btn-primary" (click)="downloadCertificate(currentCertificate?.key)"
					data-dismiss="modal">Download</button>
				<button type="button" class="btn btn-secondary" data-dismiss="modal">close</button>
			</div>
		</div>
	</div>
</div>

<!-- View Comments Modal -->
<div class="modal fade" id="view_comment_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel" style="font-size: 20px;">
					Received Comments
				</h5>
				<button type="button" #closeModal class="close align-data" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m-section">
					<div class="m-section__content">
						<div class="form-group m-form__group row">
							<div class="col-lg-12">
								<label class="col-form-label">
									<b *ngIf="comments.date !== '' || comments.time !== ''">Comments by
										{{comments.label}}
										<span *ngIf="comments.date !== ''"> on {{comments?.date}}</span>
										<span *ngIf="comments.time !== ''"> at {{comments?.time}}</span>:
									</b>
								</label>
								<span class="col-form-label" *ngIf="comments.date !== '' || comments.time !== ''">
									<br>
									<b>Reason:</b> {{comments.reason}}
									<br>
									<b>Comment:</b> {{comments.comment}}
								</span>
							</div>
						</div>
						<hr>
						<!-- <div class="form-group m-form__group row">
								<div class="col-lg-12">
									<label class="col-form-label">
										<b>Comments by SSC
											<span *ngIf="sscComments.date !== ''"> on {{comments?.date}}</span>
											<span *ngIf="sscComments.time !== ''"> at {{comments?.time}}</span>:
										</b>
									</label>
									<span class="col-form-label">
										{{sscComments?.reason}}
									</span>
								</div>
							</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Add Payment Modal -->
<div class="modal fade" (mousewheel)="scrollHandler()" id="add_payment_modal" tabindex="-1" role="dialog"
	aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Enter Batch Fee Details
				</h5>
				<button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m-section">
					<div class="m-section__content">
						<form class="m-form" *ngIf="paymentData" [formGroup]="batchFeeDetailsForm">
							<div class="form-group m-form__group row">
								<label class="col-lg-2 col-form-label">
									<b>Batch ID:</b>
								</label>
								<div class="col-lg-4 col-form-label">
									<div class="m-input-icon m-input-icon--right">
										{{paymentData.batchId}}
									</div>
								</div>
								<label class="col-lg-3 col-form-label">
									<b>Batch Name:</b>
								</label>
								<div class="col-lg-3">
									<div class="m-input-icon m-input-icon--right">
										{{paymentData.batchName}}
									</div>
								</div>
							</div>
							<div class="form-group m-form__group row">
								<label class="col-lg-2 col-form-label">
									<b>Applicant ID:</b>
								</label>
								<div class="col-lg-4 col-form-label">
									<div class="m-input-icon m-input-icon--right">
										{{userInfo.userName}}
									</div>
								</div>
								<label class="col-lg-3 col-form-label">
									<b>Applicant Name:</b>
								</label>
								<div class="col-lg-3">
									<div class="m-input-icon m-input-icon--right">
										{{userInfo.name}}
									</div>
								</div>
							</div>
							<hr>
							<label class="form-group m-form__group">
								<b>Mode of Payment</b>
								<span style="color: red">*</span>
							</label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<div class="form-select-side">
										<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
									</div>
									<select class="form-control m-input m-input--square" formControlName="modeOfPayment"
										(change)="setValidators()">
										<option value="" selected>Select payment mode</option>
										<option *ngFor="let mop of modeOfPayement">{{mop}}</option>
									</select>
									<app-form-control-messages [control]="batchFeeDetailsForm.get('modeOfPayment')"
										[name]="'Mode Of Payment'" [message]="'Select mode of payment'">
									</app-form-control-messages>
								</div>
							</div>
							<label class="form-group m-form__group"
								*ngIf="batchFeeDetailsForm.get('modeOfPayment').value != 'Cash'">
								<b>Bank Name</b>
								<span style="color: red">*</span>
							</label>
							<div class="form-group m-form__group row"
								*ngIf="batchFeeDetailsForm.get('modeOfPayment').value != 'Cash'">
								<div class="col-lg-12">
									<div class="form-select-side">
										<svg width="10px" height="12px" version="1.1" xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 129 129" enable-background="new 0 0 129 129">
											<g>
												<path
													d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z">
												</path>
											</g>
										</svg>
									</div>
									<select class="form-control m-input m-input--square" formControlName="nameOfBank">
										<option value="" selected>Select bank</option>
										<option *ngFor="let names of bankNames">{{names}}</option>
									</select>
									<app-form-control-messages [control]="batchFeeDetailsForm.get('nameOfBank')"
										[name]="'Name of Bank'" [message]="'Select name of bank'">
									</app-form-control-messages>
								</div>
							</div>
							<label class="form-group m-form__group">
								<b>Reference Number</b>
								<span style="color: red">*</span>
							</label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<input type="text" class="form-control m-input" formControlName="refNo"
										placeholder="Enter Reference Number">
									<app-form-control-messages [control]="batchFeeDetailsForm.get('refNo')"
										[name]="'Reference Number'"
										[message]="'These special characters (- / , & (), . :), alphabets and numbers are allowed'">
									</app-form-control-messages>
								</div>
							</div>
							<label class="form-group m-form__group">
								<b>Date of Payment</b>
								<span style="color: red">*</span>
							</label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<!-- <app-date-picker [model]="dateObject" (dateChanged)="onDateChange($event)"></app-date-picker> -->
									<div class="input-group">
										<input type="text" [id]="batchFeeDetailsForm.value.dateId" readonly
											class="form-control m-input calender" formControlName="dateOfPayment"
											format="DD-MM-YYYY" (blur)="setDateOfPayment($event)"
											placeholder="Select Date of Payment" />
										<div class="input-group-append">
											<span class="input-group-text">
												<i class="la la-calendar-check-o"></i>
											</span>
										</div>
									</div>
								</div>
							</div>
							<label class="form-group m-form__group">
								<b>Amount</b>
							</label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<input type="number" disabled class="form-control m-input" formControlName="amount">
									<!-- <app-form-control-messages [control]="batchFeeDetailsForm.get('amount')" [name]=" 'Amount'" [message]="'Enter amount'"></app-form-control-messages> -->
								</div>
							</div>
							<label class="form-group m-form__group">
								<b>Remarks</b>
							</label>
							<div class="form-group m-form__group row">
								<div class="col-lg-12">
									<textarea type="text" rows="5" class="form-control m-input"
										formControlName="remarks" placeholder="Enter Remarks"></textarea>
									<app-form-control-messages [control]="batchFeeDetailsForm.get('remarks')"
										[name]="'Remarks'" [message]="'Enter valid remarks'">
									</app-form-control-messages>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" data-dismiss="modal"
					[disabled]="!batchFeeDetailsForm.valid" (click)="addPayment()">
					Submit
				</button>
				<button type="button" class="btn btn-secondary" data-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>

<!-- Previde Feedback Modal -->

<div class="modal fade show" id="provide_feedback_modal" tabindex="-1" role="dialog" style="padding-right: 17px;">
	<div class="modal-dialog modal-lg" role="document">
		<div *ngIf="isFeedback" class="modal-content" style="width: 70rem;">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					{{ batchData.candidates && batchData.candidates.feedback ? 'Your Valuable Feedback' : ' How would you rate your experience?' }}
				</h5>
				<button type="button" class="close" (click)="closeModal()" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m-section">
					<div class="m-section__content">
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Trainer ID:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{userInfo?.userName ? userInfo?.userName : "N/A"}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Trainer Name:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{userInfo?.name ? userInfo?.name : "N/A"}}

								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch ID:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{batchData?.batchId? batchData.batchId : "N/A"}}
								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Batch Name:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{batchData?.batchName? batchData.batchName : "N/A"}}

								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch Date:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{(batchData?.batchStartDate ? (batchData.batchStartDate| date:"dd-MM-yyyy") : "N/A")}}
									to
									{{(batchData?.batchEndDate ? (batchData.batchEndDate | date:"dd-MM-yyyy") : "N/A")}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch Type:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{batchData?.type? batchData.type : "N/A"}}

								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Batch Mode:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ batchData.totMode || 'N/A'}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Date of Submission:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ batchData.candidates.feedback ? (batchData.candidates.feedback.date | date: "dd-MM-yyyy") : (todayDate | date: "dd-MM-yyyy")}}
								</div>
							</div>
						</div>
						<hr>
						<form class="m-form">
							<div [formGroup]="feedBackForm">
								<div formGroupName="feedBack">
									<div class="form-group m-form__group row align-data"
										*ngIf="batchData?.applicantsEnrollmentBy !== 'SSC'"
										formGroupName="feedbackForTC">
										<label class="form-group m-form__group col-lg-12">
											<b>Training Centre ID: {{batchData.tcId}}</b>
										</label>
										<label class="form-group m-form__group col-lg-12">
											<b>Training Centre Name: {{batchData.tcName}}</b>
										</label>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Pre-program communication (including ease of
													enrollment and availability of pre-read material):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Content Quality of Study Materials:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials" value=5
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials" value=4
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials" value=3
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials" value=2
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials" value=1
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Quality of Training/ Assessment Location (or
													Training/ Assessment Platform in case of Online mode):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Quality of Training and Assessment Tools, Equipment
													and Infrastructure:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" value=4 class="radio"
															type="radio">
														<span></span>
													</label>

												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Post-program communication/ instructions (including
													support with Skill India Digital Hub, OJT briefing):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<hr *ngIf="batchData?.applicantsEnrollmentBy !== 'SSC'">
									<div class="form-group m-form__group row"
										*ngIf="(batchData.type !== 'Training of Trainer-Existing' && batchData.type !== 'Training of Assessor-Existing')">
										<span class="col-12" formArrayName="feedbackForMT"
											*ngFor="let mtrainerFeedBack of feedBackForm.controls.feedBack.controls.feedbackForMT.controls; let s = index">
											<span [formGroupName]="s">
												<label class="form-group m-form__group col-lg-12">
													<b>Master Trainer ID:
														{{mtrainerFeedBack.value.userName}}</b>
												</label>
												<label class="form-group m-form__group col-lg-12">
													<b>Master Trainer Name:
														{{mtrainerFeedBack.value.name}}</b>
													<span class="pull-right">
														<b>Job Role Name(QP Code):
															{{mtrainerFeedBack.value.qpName}}({{mtrainerFeedBack.value.qpCode}})</b>
													</span>
												</label>
												<table class="col-lg-12">
													<thead>
														<th class="width1"></th>
														<th>Highly Satisfied (5)</th>
														<th>Satisfied (4)</th>
														<th>Neutral (3)</th>
														<th>Dissatisfied (2)</th>
														<th>Highly Dissatisfied (1)</th>
													</thead>
													<tr>
														<td class="width1">Knowledge of Subject:</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="knowledge" value=5 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="knowledge" value=4 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="knowledge" value=3 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="knowledge" value=2 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="knowledge" value=1 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
													</tr>
													<tr>
														<td class="width1">Organization and preparation of the sessions:
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="sessions" value=5 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="sessions" value=4 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="sessions" value=3 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="sessions" value=2 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="sessions" value=1 class="radio"
																	type="radio">
																<span></span>
															</label>
														</td>
													</tr>
													<tr>
														<td class="width1">Presentation Style and Delivery:</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="presentation" value=5
																	class="radio" type="radio">
																<span></span>
															</label>

														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="presentation" value=4
																	class="radio" type="radio">
																<span></span>
															</label>

														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="presentation" value=3
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="presentation" value=2
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="presentation" value=1
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
													</tr>
													<tr>
														<td class="width1">Usage of Examples of Practical Application:
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="exampleUsage" value=5
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="exampleUsage" value=4
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="exampleUsage" value=3
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="exampleUsage" value=2
																	class="radio" type="radio">
																<span></span>
															</label>

														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="exampleUsage" value=1
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
													</tr>
													<tr>
														<td class="width1">Interactive & Participative Approach:</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="interactive" value=5
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="interactive" value=4
																	class="radio" type="radio">
																<span></span>
															</label>

														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="interactive" value=3
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="interactive" value=2
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="interactive" value=1
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
													</tr>
													<tr>
														<td class="width1">Coverage of Curriculum:</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="curriculum" value=5
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="curriculum" value=4
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="curriculum" value=3
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="curriculum" value=2
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
														<td class="width2">
															<label class="radio">
																<input formControlName="curriculum" value=1
																	class="radio" type="radio">
																<span></span>
															</label>
														</td>
													</tr>
												</table>
											</span>
											<hr>
										</span>
									</div>
									<div *ngIf="batchData.type !== 'Training of Trainer-Existing' && batchData.type !== 'Training of Assessor-Existing'"
										class="form-group m-form__group row">
										<span class="col-12" formGroupName="feedbackForMTTraining">
											<label class="form-group m-form__group">
												<b>Feedback on Training:</b>
											</label>
											<table class="col-lg-12">
												<thead>
													<th class="width1"></th>
													<th>Highly Satisfied (5)</th>
													<th>Satisfied (4)</th>
													<th>Neutral (3)</th>
													<th>Dissatisfied (2)</th>
													<th>Highly Dissatisfied (1)</th>
												</thead>
												<tr>
													<td class="width1">Extent of Learning:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningExtent" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningExtent" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningExtent" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningExtent" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningExtent" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Learning Environment:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningEnvironment" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningEnvironment" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningEnvironment" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningEnvironment" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="learningEnvironment" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
											</table>
										</span>
									</div>
									<hr
										*ngIf="(batchData.type !== 'Training of Trainer-Existing' && batchData.type !== 'Training of Assessor-Existing')">
									<div formArrayName="feedbackForAssessor" class="form-group m-form__group row"
										*ngFor="let assessorFeedBack of feedBackForm.controls.feedBack.controls.feedbackForAssessor.controls; let j = index">
										<span [formGroupName]="j" class="col-12">
											<label class="form-group m-form__group col-lg-12">
												<b>Assessor ID: {{ assessorFeedBack.value.userName }}</b>
											</label>
											<label class="form-group m-form__group col-lg-12">
												<b>Assessor Name: {{ assessorFeedBack.value.name }}</b>
												<span class="pull-right">
													<b>Job Role Name(QP Code):
														{{assessorFeedBack.value.qpName}}({{assessorFeedBack.value.qpCode}})</b>
												</span>
											</label>
											<table class="col-lg-12">
												<thead>
													<th class="width1"></th>
													<th>Highly Satisfied (5)</th>
													<th>Satisfied (4)</th>
													<th>Neutral (3)</th>
													<th>Dissatisfied (2)</th>
													<th>Highly Dissatisfied (1)</th>
												</thead>
												<tr>
													<td class="width1">Pre-Assessment Brief:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="preAssessment" value=5 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="preAssessment" value=4 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="preAssessment" value=3 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="preAssessment" value=2 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="preAssessment" value=1 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Conduct of Assessor:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="conduct" value=5 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="conduct" value=4 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="conduct" value=3 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="conduct" value=2 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="conduct" value=1 class="radio"
																type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Overall Assessment Experience:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="assessmentExperience" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="assessmentExperience" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="assessmentExperience" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="assessmentExperience" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="assessmentExperience" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
											</table>
											<hr>
										</span>
									</div>
									<div class="form-group m-form__group row align-data">
										<label class="form-group m-form__group">
											<b>Overall Program Rating</b>
										</label>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Overall Program Rating:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" value=2 type="radio"
															class="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
										<hr>
									</div>
									<hr>
									<div class="form-group m-form__group row align-data">
										<label class="form-group m-form__group col-12">
											<b>Would you recommend this program to other trainers/assessors?</b>
										</label>
										<td class="width3 col-2">
											<label for="radio">Yes</label>
											<label class="radio">
												<input formControlName="recommendation" value="Yes" class="radio"
													type="radio">
												<span></span>
											</label>
										</td>
										<td class="width4">
											<label for="radio">No</label>
											<label class="radio">
												<input formControlName="recommendation" value="No" class="radio"
													type="radio">
												<span></span>
											</label>
										</td>
										<hr>
									</div>
									<div>
										<label class="form-group m-form__group">
											Comment:
											<span class="red">*</span>
										</label>
										<div>
											<textarea type="text" formControlName="overAllComment"
												class="form-control m-input" rows="5"
												placeholder="Your comments goes here..."></textarea>
											<app-form-control-messages class="col-12"
												[control]="feedBackForm.get('feedBack').get('overAllComment')['controls']"
												[name]="'Comments'"></app-form-control-messages>
										</div>
									</div>

								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="submit" *ngIf="!batchData.candidates.feedback" data-dismiss="modal"
					class="btn btn-primary" [disabled]="!feedBackForm.valid" (click)="feedbackSubmitted()">
					Submit Feedback
				</button>
				<button type="button" class="btn btn-secondary" data-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
